var render = function () {
  var _vm$currentRound, _vm$currentRound2, _vm$currentRound2$myC, _vm$currentRound2$myC2, _vm$currentRound3, _vm$currentRound3$myC, _vm$currentRound3$myC2, _vm$currentRound4, _vm$currentRound4$myC, _vm$currentRound4$myC2, _vm$currentRound5, _vm$answers$_vm$progr;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [!_vm.showPDF ? _c('div', {
    class: ['step-parent', 'step-parent-active']
  }, [_c('div', {
    staticClass: "mychoice-instructions"
  }, [_c('audio-toggle-button'), _c('h1', [_vm._v(_vm._s((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.instructions))])], 1), _c('div', {
    staticClass: "image-wrapper"
  }, [(_vm$currentRound2 = _vm.currentRound) !== null && _vm$currentRound2 !== void 0 && (_vm$currentRound2$myC = _vm$currentRound2.myChoiceImage) !== null && _vm$currentRound2$myC !== void 0 && (_vm$currentRound2$myC2 = _vm$currentRound2$myC.image) !== null && _vm$currentRound2$myC2 !== void 0 && _vm$currentRound2$myC2.src ? _c('img', {
    attrs: {
      "src": (_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : (_vm$currentRound3$myC = _vm$currentRound3.myChoiceImage) === null || _vm$currentRound3$myC === void 0 ? void 0 : (_vm$currentRound3$myC2 = _vm$currentRound3$myC.image) === null || _vm$currentRound3$myC2 === void 0 ? void 0 : _vm$currentRound3$myC2.src,
      "alt": (_vm$currentRound4 = _vm.currentRound) === null || _vm$currentRound4 === void 0 ? void 0 : (_vm$currentRound4$myC = _vm$currentRound4.myChoiceImage) === null || _vm$currentRound4$myC === void 0 ? void 0 : (_vm$currentRound4$myC2 = _vm$currentRound4$myC.image) === null || _vm$currentRound4$myC2 === void 0 ? void 0 : _vm$currentRound4$myC2.description
    }
  }) : _vm._e()]), _c('label', {
    staticClass: "question",
    attrs: {
      "for": "answerWithButton"
    }
  }, [_vm._v(_vm._s((_vm$currentRound5 = _vm.currentRound) === null || _vm$currentRound5 === void 0 ? void 0 : _vm$currentRound5.myChoiceQuestion))]), _c('div', {
    staticClass: "answer"
  }, [_c('answer-with-button', {
    key: _vm.progress.roundIndex,
    attrs: {
      "done-callback": _vm.finishRound,
      "answer": (_vm$answers$_vm$progr = _vm.answers[_vm.progress.roundIndex]) === null || _vm$answers$_vm$progr === void 0 ? void 0 : _vm$answers$_vm$progr.answer
    }
  })], 1), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.showPlayAgain ? _c('button', {
    staticClass: "play-again pure-button",
    attrs: {
      "transition": "fade-05"
    },
    on: {
      "click": _vm.playAgain
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.playAgainButton,
      "alt": ""
    }
  }), _c('span', [_vm._v("Play Instructions Again")])]) : _vm._e()])]) : _vm._e(), !!_vm.showPDF ? _c('div', {
    staticClass: "full-screen-row"
  }, [_vm.pdfPreviewSrc ? _c('div', {
    staticClass: "parent"
  }, [_c('iframe', {
    staticClass: "half-screen-column half-print",
    attrs: {
      "src": _vm.pdfPreviewSrc,
      "title": "Pdf preview"
    },
    on: {
      "load": _vm.onIframeLoad
    }
  }), _c('div', {
    staticClass: "container-buttons"
  }, [!_vm.isMobile ? _c('button', {
    class: ['btn-common', _vm.showButtons ? 'btn-show' : ''],
    on: {
      "click": _vm.print
    }
  }, [_c('div', {
    staticClass: "action-button-content"
  }, [_vm._v("Print")])]) : _vm._e(), _c('button', {
    class: ['btn-common', _vm.showButtons ? 'btn-show' : ''],
    on: {
      "click": _vm.done
    }
  }, [_c('div', {
    staticClass: "action-button-content"
  }, [_vm._v("Done")])])])]) : _c('div', [_c('div', {
    staticClass: "spinner"
  })])]) : _vm._e()])])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }